import script from "./TraCuuHoSo.vue?vue&type=script&lang=ts&setup=true"
export * from "./TraCuuHoSo.vue?vue&type=script&lang=ts&setup=true"

import "./TraCuuHoSo.vue?vue&type=style&index=0&id=c2a43be6&lang=css"

const __exports__ = script;

export default __exports__